export default __webpack_public_path__ + "static/media/middle-icon.fb7fdf33.svg";